import { Stack, Typography } from "@mui/material";
import React from "react";
import { IControlledMutator, IDisable, Nullable } from "sonobello.utilities.react";

import { IMedicalFormItemConfigProps, IMedicalFormItemProps } from "../../Types/IMedicalFormItemProps";
import MedicalFormItemState from "../../Types/MedicalFormItemState";

export interface IBaseComposableFormItemProps {
  /** The form element which will control the value of this item (checkbox, field, etc). */
  FormElement: React.FC<IControlledMutator<Nullable<string>> & IDisable>;
}

const BaseComposableFormItem: React.FC<
  IBaseComposableFormItemProps & IMedicalFormItemConfigProps & IMedicalFormItemProps
> = ({ disabled, formItemId, formState, messages, onChange, FormElement, ChildFormItem, ...rest }) => {
  return (
    <Stack sx={{ opacity: disabled ? 0.4 : 1 }} spacing={2}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
        <Stack>
          {messages.map(({ text, typography }) => (
            <Typography variant={typography || "body2"} key={text}>
              {text}
            </Typography>
          ))}
        </Stack>
        <FormElement
          value={formState[formItemId] || ""}
          onChange={v => onChange(new MedicalFormItemState(formItemId, v))}
          disabled={disabled}
        />
      </Stack>
      {ChildFormItem && <ChildFormItem {...{ disabled, formState, onChange }} {...rest} />}
    </Stack>
  );
};

export default BaseComposableFormItem;
